<template>
  <div>
    <div class="text-center">
      <h2  class="font-weight-light">Your Addresses</h2>
    </div>

    <v-row 
      justify="center"
      class="ma-5"
    >
      <v-btn
        to="/addresses-add"
        color="primary"
        dark
      >
        Add Address
      </v-btn>
    </v-row>

    <v-container
    fill-height
    >
      <v-row>
        <v-col xs="12" sm="6" md="4" lg="3" class="d-flex flex-column" v-for="(address) in addresses" :key="address.Id">
          <v-card class="elevation-5 flex d-flex flex-column">
            <v-card-title primary-title>
              <div
                v-if="address.Default"
              >
                <v-chip>Default</v-chip>
              </div>
            </v-card-title>
            <v-card-text class="flex">
              <p>{{address.Line1}}</p>
              <p>{{address.Line2}}</p>
              <p>{{address.City}}, {{address.State}} {{address.PostalCode}}</p>
              <p>{{address.Country}}</p>
              <div v-if="address.DeliveryNotes">
                <p class="font-weight-bold">Delivery notes:</p>
                <p>{{address.DeliveryNotes}}</p>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                v-on:click="delAddress(address.Id)"
                text
                color="red"
                :loading="loading"
              >
              Remove
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue"
                v-on:click="setDefaultAddress(address.Id)"
                :loading="loading"
                v-if="!address.Default"
                >
                Set Default
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div> 
</template>

<script>
export default {
  name: "Addresses",
  data() {
    return {
      errors: [],
      loading: false
    }
  },
  computed: {
    addresses() {
      return this.$store.state.addresses.Addresses
    }
  },
  beforeMount(){
    this.$store.dispatch('FetchAddresses')
  },
  methods: {
    delAddress(id) {
      this.loading = true

      this.$axios.delete('addresses/{id}?id=' + id)
        .then(() => {
          this.loading = false
          this.errors = []
        })
        .then(()=>{
          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'Address removed sucessfully.'
          });
        })
        .then(()=>{
          this.$store.dispatch('FetchAddresses')
        })
        .catch((error) => {
          this.loading = false
          if (!error.response) {
            this.errors = ['Network Error']
          } else if (error.response.status === status.CONFLICT) {
            this.errors = ['User already exists']
          } else if (error.response.status === status.UNPROCESSABLE_ENTITY) {
            this.errors = error.response.data.errors
          }
          this.errors = ['Unknown Error']
        })
    },
    setDefaultAddress(id) {
      this.loading = true

      this.$axios.post('addresses/setdefault/{id}?id=' + id)
        .then(() => {
          this.loading = false
          this.errors = []
        })
        .then(()=>{
          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'Default address changed sucessfully.'
          });
        })
        .then(()=>{
          this.$store.dispatch('FetchAddresses')
        })
        .catch((error) => {
          this.loading = false
          if (!error.response) {
            this.errors = ['Network Error']
          } else if (error.response.status === status.CONFLICT) {
            this.errors = ['User already exists']
          } else if (error.response.status === status.UNPROCESSABLE_ENTITY) {
            this.errors = error.response.data.errors
          }
          this.errors = ['Unknown Error']
        })
    }
  }
}
</script>
